import * as React from 'react'

import {LabelCountry} from "@components";

export default function retailerColumn() {
	return {
		name: 'retailer',
		render: (value, { country }) => {
			return <LabelCountry country={country} label={value} />
		}
	}
}